import * as React from "react"
import { svgIconStyles } from "@digits-shared/components/SVG/svgIconStyles"
import { SvgArrowCircleUpSolid } from "@digits-shared/components/SVGIcons/solid/ArrowCircleUpSolid.svg"
import useSession from "@digits-shared/hooks/useSession"
import colors from "@digits-shared/themes/colors"
import styled from "styled-components"
import { DeferredSnackbar } from "src/frontend/components/Shared/ManagedModals/DeferredSnackbar"
import { type ManagedSnackbarName } from "src/frontend/components/Shared/ManagedModals/state/types"
import {
  useHideSnackbar,
  useWasSnackbarDismissed,
} from "src/frontend/components/Shared/ManagedModals/useManagedSnackbar"
import { useIsInIcp } from "src/frontend/components/Shared/PLG/Upsell/upsell"
import { useFrontendPathGenerator } from "src/frontend/hooks/useFrontendPathGenerator"
import routes from "src/frontend/routes"
import type FrontendSession from "src/frontend/session"

const UpgradeIcon = styled(SvgArrowCircleUpSolid)`
  ${svgIconStyles(colors.secondary)};
  margin-left: 0 !important;
  path {
    stroke: ${colors.transparent} !important;
  }
`

export const UpsellSnackbar: React.FC<{
  snackbarName: ManagedSnackbarName
  message: string
  description: string
}> = ({ snackbarName, message, description }) => {
  const wasSnackbarDismissed = useWasSnackbarDismissed(snackbarName)
  const isInIcp = useIsInIcp(wasSnackbarDismissed)
  const dismissSnackbar = useHideSnackbar(snackbarName, "Persistent")
  const { currentLegalEntity } = useSession<FrontendSession>()
  const pathGenerator = useFrontendPathGenerator()

  return (
    isInIcp &&
    !wasSnackbarDismissed && (
      <DeferredSnackbar
        position="bottom-right"
        showIcon={false}
        message={message}
        description={description}
        onClick={dismissSnackbar}
        onCloseClick={dismissSnackbar}
        delayMs={2_000}
        to={pathGenerator(routes.subscriptionSettings, {
          leSlug: currentLegalEntity?.slug,
        })}
        buttonVariant="primary"
        buttonContents={
          <>
            <UpgradeIcon /> Upgrade
          </>
        }
      />
    )
  )
}
